module.exports = __webpack_public_path__ + "assets/img/contact-image.86af449d.png";